import React, { useEffect, useState } from 'react';
import {
  Box,
  Card,
  Dialog,
  DialogContent,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  Typography
} from '@mui/material';
import PropTypes from 'prop-types';
import { firestore } from '../../../contexts/FirebaseContext';
import { filter } from 'lodash';
import { UserListHead, UserListToolbar } from '../user/list';
import { useTheme } from '@mui/material/styles';
import { fCurrency } from '../../../utils/formatNumber';
import { fDate, fDateTime } from '../../../utils/formatTime';
import ReportListToolbar from '../usuarios/ReportListToolbar';
import Scrollbar from '../../Scrollbar';
import Label from '../../Label';
import SearchNotFound from '../../SearchNotFound';
import Page from '../../PageAlt';
import TransactionListToolbar from './TransactionsListToolbar';

function DialogHistory({ open, onClose, transactions }) {
  // console.log(transactions);
  const handleClose = () => {
    onClose(false);
  };
  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogContent>
        <PaymentReports transactions={transactions} />
      </DialogContent>
    </Dialog>
  );
}

export default DialogHistory;

const TABLE_HEAD = [
  { id: '' },
  { id: 'categoryService', label: 'Servicio', alignRight: false },
  { id: 'reason', label: 'Descripcion', alignRight: false },
  { id: 'message', label: 'Mensaje', alignRight: false },
  { id: 'amount', label: 'Monto', alignRight: false },
  { id: 'previous', label: 'Saldo anterior', alignRight: false },
  { id: 'leter', label: 'Saldo resultante', alignRight: false },
  { id: 'updated_at', label: 'Fecha actualizacion', alignRight: false }
  //   { id: 'wallet', label: 'Wallet', alignRight: false },
  //   { id: 'status', label: 'Status', alignRight: false }
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user?.displayName?.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

// const userList = [];

export function PaymentReports({ transactions = [] }) {
  //   const { themeStretch } = useSettings();
  const theme = useTheme();
  //   const dispatch = useDispatch();
  //   const { userList } = useSelector((state) => state.dagpacket);
  //   //   const [userListLocal, setUserListLocal] = useState([]);
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [categoryService, setCategoryService] = useState(null);
  const [dateFilter, setDateFilter] = useState(null);

  console.log(dateFilter);

  // console.log(transactions);

  //   useEffect(() => {
  //     async function getUsers() {
  //       await firestore.collection('users').onSnapshot((snapshot) => {
  //         const userList = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  //         console.log(userList);
  //         dispatch(setUserList(userList));
  //       });
  //     }
  //     getUsers();
  //   }, [dispatch]);

  //   useEffect(() => {
  //     setUserListLocal(userList);
  //   }, [setUserListLocal, userList]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = transactions.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
    // console.log(filterName);
  };

  //   const handleDeleteUser = (userId) => {
  //     dispatch(deleteUser(userId));
  //   };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - transactions.length) : 0;

  const filterStatus = (data, category) => {
    if (category === 'SERVICIO') {
      return data.filter((item) => item.categoryService === category);
    }
    if (category === 'PAQUETERIA') {
      return data.filter((item) => item.categoryService === category);
    }
    if (category === 'RECARGA') {
      return data.filter((item) => item.categoryService === category);
    }
    // if (status === 'APLICADO') {
    //   return data.filter(
    //     (item) => item.status !== 'CANCELADO' && item.status !== 'PENDIENTE' && item.status !== 'RECHAZADO'
    //   );
    // }
    return data;
  };

  const filterByDate = (data, dateInfo) => {
    if (dateInfo) {
      return data.filter((item) => Date.parse(item.updated_at.toDate()) > dateInfo);
    }

    return data;
  };

  const filteredByDate = filterByDate(transactions, dateFilter);

  const filteredByStatus = filterStatus(filteredByDate, categoryService);

  const filteredUsers = applySortFilter(filteredByStatus, getComparator(order, orderBy), filterName);

  const isUserNotFound = filteredUsers.length === 0;

  return (
    <Page title="Historial de transacciones">
      {/* <Container maxWidth={themeStretch ? false : 'lg'}> */}
      <Card>
        <Box padding="10px 15px">
          <Typography variant="subtitle1" fontSize="25px">
            Historial de transacciones
          </Typography>
          <Divider />
        </Box>
        <TransactionListToolbar
          numSelected={selected.length}
          filterName={filterName}
          onFilterName={handleFilterByName}
          handleStatus={setCategoryService}
          handleDate={setDateFilter}
        />

        <Scrollbar>
          <TableContainer sx={{ minWidth: 800 }}>
            <Table>
              <UserListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={transactions.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
                onSelectAllClick={handleSelectAllClick}
                checkboxOption={false}
              />
              <TableBody>
                {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                  const {
                    id,
                    categoryService,
                    message,
                    updated_at,
                    amount,
                    increase,
                    reason,
                    previousBalance,
                    laterBalance
                  } = row;
                  const isItemSelected = selected.indexOf(id) !== -1;
                  return (
                    <TableRow
                      hover
                      key={id}
                      tabIndex={-1}
                      role="checkbox"
                      selected={isItemSelected}
                      aria-checked={isItemSelected}
                    >
                      <TableCell align="right">
                        {/* <UserMoreMenu onDelete={() => handleDeleteUser(id)} userName={displayName} data={row} /> */}
                      </TableCell>

                      <TableCell align="left">{categoryService}</TableCell>
                      <TableCell align="left">{reason}</TableCell>
                      <TableCell align="left">{message}</TableCell>
                      <TableCell align="left">
                        <Typography color={increase ? 'secondary' : 'error'}>
                          {increase ? `+ ${fCurrency(amount)}` : `- ${fCurrency(amount)}`}
                        </Typography>
                      </TableCell>
                      <TableCell align="left">{fCurrency(previousBalance)}</TableCell>
                      <TableCell align="left">{fCurrency(laterBalance)}</TableCell>
                      <TableCell align="left">{fDateTime(updated_at.toDate())}</TableCell>
                      {/* <TableCell align="left">{isVerified ? 'Yes' : 'No'}</TableCell> */}
                    </TableRow>
                  );
                })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
              {isUserNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <SearchNotFound searchQuery={filterName} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </Scrollbar>

        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={transactions.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
      {/* <AppUsuarios /> */}
      {/* </Container> */}
    </Page>
  );
}
